import { render, staticRenderFns } from "./XertAuthentication.vue?vue&type=template&id=f5d9e21c&scoped=true"
import script from "./XertAuthentication.vue?vue&type=script&lang=js"
export * from "./XertAuthentication.vue?vue&type=script&lang=js"
import style0 from "./XertAuthentication.vue?vue&type=style&index=0&id=f5d9e21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d9e21c",
  null
  
)

export default component.exports